module.exports = __webpack_public_path__ + "images/iosLogo-a9e75fb47da686daa0db144d2103af3b.png";